import React, { useEffect, useCallback } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import apiClient from "../../api/apiClient";
import { all_routes } from "../../Router/all_routes";
import { PageContainer } from "../../components/layout/PageContainer";
import { PageHeader, PageHeaderHeading } from "@/components/ui/page-header";
import PredefinedRepairForm from "./PredefinedRepairForm";
import { useSelector } from "react-redux";

const AddPredefinedRepair = () => {
  const permissions = useSelector((state) => state.userpermission_data);
  const hasPermission = useCallback(
    (permission) => {
      return permissions && permissions.includes(permission);
    },
    [permissions],
  );
  const navigate = useNavigate();
  const queryClient = useQueryClient();


  useEffect(() => {
    if (!hasPermission("predefined repair job create")) {
      toast.error("Unauthorized", {
        description:
          "You do not have permission to access this page. Redirecting...",
      });
      setTimeout(() => {
        navigate(all_routes.dashboard);
      }, 3000);
    }
  }, [hasPermission, navigate]);

  const createMutation = useMutation({
    mutationFn: async (newData) => {
      const response = await apiClient.post(
        `/predefined-repair-jobs`,
        newData,
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["predefined-repairs"] });
      toast.success("Predefined repair template created successfully");
      navigate(all_routes.predefinedRepairs);
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Failed to create template");
    },
  });

  return (
    <PageContainer>
      <PageHeader className="mb-6">
        <PageHeaderHeading>Add Predefined Repair Template</PageHeaderHeading>
      </PageHeader>
      <PredefinedRepairForm
        onSubmit={(data) => createMutation.mutate(data)}
        isSubmitting={createMutation.isPending}
        onCancel={() => navigate(all_routes.predefinedRepairs)}
      />
    </PageContainer>
  );
};

export default AddPredefinedRepair;



